jQuery(document).ready(function() {
  // jQuery('.GSRecommendationBG .salemaximize__product_redirect_link').on('click', function (e) {
  //   e.preventDefault();
  //   window.location.href = jQuery(this).attr('href');
  //   console.log(jQuery(this).attr('href'));
  //   return false; 
  // });

  var intervalId = setInterval(function () {
      jQuery('.GSRecommendationBG .salemaximize__product_redirect_link').each(function() {
        jQuery(this).removeAttr('target');
      });
   }, 5000);

  var progressWidth = setInterval(function () {
      var elementWidth = jQuery('.salemaximize__progress-bar-fill').css('width');
      if(elementWidth == '334px') {
        jQuery('.salemaximize__progress-bar-fill').css('background-color', '#67A343!important');
        jQuery('.salemaximize__progress-bar-breakpoint').css('background-color', '#67A343!important');
      } else {
        jQuery('.salemaximize__progress-bar-fill').css('background-color', '#D45957!important');
        jQuery('.salemaximize__progress-bar-breakpoint').css('background-color', '#D45957!important');
      }
   }, 100);

  jQuery('header nav summary#HeaderMenu-products span').click(function() {
    window.location.href = "/collections/all";
  });
});